import { ScreenLayout } from "../../layout/components";
import { RootStackScreenProps } from "../../navigation/Navigation.types";
import { ResetPassword } from "../../common/reset-password";

export default function SetPasswordScreen({ route }: RootStackScreenProps<"set-password">) {
  return (
    <ScreenLayout>
      <ResetPassword
        title="Set Password"
        authParams={route.params}
        body={"Account for user {{email}} has been created.\nPlease set password and proceed to login."}
      />
    </ScreenLayout>
  );
}
